module.exports = __webpack_public_path__ + "static/statesman_sec2-4b4ab625cb8074e850052aece14fcea8.png";